import styles from './sidebar.module.css';
import { MenuItem, SidebarProps } from './sidebar.type';
import logo from '../../assets/company_logo.png';
import { NavLink } from 'react-router-dom';
import leftArrow from '../../assets/left-arrow.png';
import close from '../../assets/close.png';
import { route } from '../../service/router';
import { Trans } from 'react-i18next';
import { useResponsiveLayout } from '../../hooks/useResponsiveLayout';
import { UserType } from '@inplay/models';

const Sidebar = (props: SidebarProps) => {
  const menuItems: MenuItem[] = [
    {
      name: 'menuItems.dashboard',
      link: route.dashboard,
      show: true,
    },
    {
      name: 'menuItems.userManagement',
      link: route.userManagement,
      show:
        props.userType !== UserType.VENUE_STAFF &&
        props.userType !== UserType.VENUE_BRANCH_LOGIN,
    },
    {
      name: 'menuItems.sweeps',
      link: route.sweeps,
      show: true,
    },
    {
      name: 'menuItems.harmReports',
      link: route.harmReports,
      show: true,
    },
    {
      name: 'menuItems.interventionReports',
      link: route.interventionReports,
      show: true,
    },
    {
      name: 'menuItems.exclusionOrders',
      link: route.exclusionOrders,
      show: true,
    },
  ];

  const { isTablet } = useResponsiveLayout();

  return (
    <>
      {isTablet && props.isSidebarOpen && <div className={styles.overlay} />}
      <nav
        className={`${styles.sidebar} ${!props.isSidebarOpen && styles.close} ${
          isTablet && styles.tablet
        }`}
      >
        {props.isSidebarOpen && isTablet ? (
          <button className={styles.close} onClick={props.onClose}>
            <img src={close} alt="" />
          </button>
        ) : (
          <button className={styles.close} onClick={props.onClose}>
            <img src={leftArrow} alt="" />
          </button>
        )}
        <div className={styles.brand}>
          <img
            src={
              process.env.REACT_APP_S3_BUCKET_URL
                ? `${process.env.REACT_APP_S3_BUCKET_URL}/assets/logo.png`
                : logo
            }
            alt="logo"
            className="w-12 h-12"
          />
        </div>
        <ul className={styles.menu}>
          {menuItems
            .filter((menuItem: MenuItem) => menuItem.show)
            .map((menuItem: MenuItem, index: number) => (
              <li
                key={index}
                onClick={() => {
                  if (isTablet) {
                    props.onClose();
                  }
                }}
              >
                <NavLink
                  to={menuItem.link}
                  className={`${styles.menuItem} ${
                    props.currentPath === menuItem.link && styles.active
                  }`}
                >
                  <Trans i18nKey={menuItem.name} />
                </NavLink>
              </li>
            ))}
        </ul>
      </nav>
    </>
  );
};

export default Sidebar;
